/**
 * T2-5707: which Job.status values allow DO to edit proposedRate.
 * POSTED=1, PARTIAL=2, OFFER_EXPIRED=5. Booked/completed/etc blocked.
 */
export const EDITABLE_PROPOSED_RATE_JOB_STATUSES = new Set([1, 2, 5]);

export const canEditProposedRate = (status: number | string | null | undefined): boolean => {
  if (status === null || status === undefined || status === '') {
    return false;
  }
  return EDITABLE_PROPOSED_RATE_JOB_STATUSES.has(Number(status));
};
